import { checkDirtyStoredValue } from '@helpers'
import { CriteriaType } from '@constants'
import { POSTStoredSearchFilterType } from '@types'

import { SearchAssistantStoredValueMapper } from './SearchAssistantStoredValueMapper'

/**
 * преобразование массива с текущими заполннными полями в сохраненные критерии для POST запроса
 * @param filters - массив с текущими  заполненными полями
 * @returns сохраненные критерии со значениями
 */
class SearchAssistantStoredSearchFiltersMapper {
  static toDto(filtersModel: CriteriaType[]): POSTStoredSearchFilterType[] {
    return filtersModel
      .map(criteria => {
        if (
          criteria.storedValues.some(({ value, searchRule }) =>
            checkDirtyStoredValue(value, searchRule)
          )
        ) {
          return {
            codeSearchFilter: criteria.codeCriteria,
            storedValues: SearchAssistantStoredValueMapper.toDto(criteria.storedValues),
          }
        }

        return undefined
      })
      .filter(Boolean) as POSTStoredSearchFilterType[]
  }
}

export { SearchAssistantStoredSearchFiltersMapper }
